import { SET_ALL_BOTS_COUNT } from "./types";
export const setAllBotsCount = (botsCount) => {
  // console.log("bots Count :", botsCount);
  return (dispatch) => {
    dispatch({
      type: SET_ALL_BOTS_COUNT,
      payload: {
        botsCount: botsCount,
      },
    });
  };
};
